// extracted by mini-css-extract-plugin
export var banner = "Snackbar-module--banner--05326";
export var error = "Snackbar-module--error--e44b6";
export var info = "Snackbar-module--info--8c0f2";
export var snackbar = "Snackbar-module--snackbar--7bddb";
export var success = "Snackbar-module--success--b51ec";
export var tooltip = "Snackbar-module--tooltip--48691";